import React from 'react'
import useLoadDuplicate from 'tennders-market/load/hooks/useLoadDuplicate'
import GHref from 'tennders-market/common/components/element/GHref'
import useTranslation from 'next-translate/useTranslation'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import IconDuplicate from '../../../../../icons/icon-duplicate.svg'

interface RowDuplicateActionProps {
  transaction: TransactionType
  isHeader?: boolean
}

const RowDuplicateAction = ({ transaction, isHeader = false }: RowDuplicateActionProps) => {
  const { loadDuplicate, loading } = useLoadDuplicate()
  const { t } = useTranslation()

  return (
    <GHref
      submitting={loading}
      disabled={loading}
      onClick={() => loadDuplicate(transaction.matchedLoad?.id)}
      className={'cell-icon d-flex col flex-center' + (isHeader ? ' bg-dark' : ' btn-link')}
    >
      <IconDuplicate className="m-auto" />
      <div className="m-auto icon-label">
        {t('tableRow:duplicate')}
      </div>
    </GHref>
  )
}

export default React.memo(RowDuplicateAction)
